import { Routes, Route } from 'react-router-dom';
import VisitSchedulePage from 'src/components/Conduct/SubjectTracking/VisitSchedule/VisitSchedulePage';
import NotFound from 'src/components/common/NotFound';
import MainTabs from 'src/components/maintabs/MainTabs';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainTabs />} />
      <Route path="/visit-schedule" element={<VisitSchedulePage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
